(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("flat-light-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["flat-light-panelless"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["FlatLightPanelless"] = factory();
})(this, () => {
return 